// Index file for all survey specifications
// This file will be used for automatic navigation generation

import { pediatricHealthAssessmentData } from './pediatricHealthAssessment';

export const surveySpecifications = [
  {
    id: 'pediatric-health-assessment',
    title: 'Pediatric Health Assessment',
    description: 'Comprehensive health assessment for children and adolescents',
    version: '7.4.25',
    lastUpdated: '2025-01-08',
    data: pediatricHealthAssessmentData,
    queryParam: 'pediatric-health-assessment' // For ?specification=pediatric-health-assessment
  }
  // Future specifications will be added here
];

// Helper function to get specification by ID
export const getSpecificationById = (id) => {
  return surveySpecifications.find(spec => spec.id === id);
};

// Helper function to get all specification titles for navigation
export const getSpecificationTitles = () => {
  return surveySpecifications.map(spec => ({
    id: spec.id,
    title: spec.title,
    queryParam: spec.queryParam,
    href: `/documentation?specification=${spec.queryParam}`
  }));
};